class ProjectType {
	constructor(i, name, url, description, img) {
		this.index = i;
		this.projectName = name;
		this.url = url;
		this.description = description;
		this.image = img;
	}
}

export default ProjectType;
